import { render, staticRenderFns } from "./businessManagement.vue?vue&type=template&id=0da8e1e8&scoped=true&"
import script from "./businessManagement.vue?vue&type=script&lang=js&"
export * from "./businessManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da8e1e8",
  null
  
)

export default component.exports